import Vue from 'vue'
import moment from "moment";
import accounting from "accounting";
import VuetableFieldSequence from 'vuetable-2/src/components/VuetableFieldSequence.vue'
import VuetableFieldCheckbox from 'vuetable-2/src/components/VuetableFieldCheckbox.vue'
Vue.component('vuetable-field-checkbox', VuetableFieldCheckbox)

export default [
  {
    name: "fileName",
    title: 'File Name',
    width: "35%",
    sortField: "fileName",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return "N/A";
      }
    }
  },
  {
    name: "documentType",
    title: 'File Type',
    width: "25%",
    sortField: "documentType.type",
    formatter(value) {
      if (value && value.type) {
        return value.type;
      }
    }
  },
  {
    name: "createdOn",
    title: 'Date',
    width: "25%",
    sortField: "createdOn",
    formatter(value) {
      if (value) {
        return moment(new Date(value)).format("YYYY-MM-DD");
      }
    }

  },
  {
    name: "createdOn",
    title: 'Time',
    width: "25%",
    sortField: "createdOn",
    formatter(value) {
      if (value) {
        return moment(new Date(value)).format("H:m");
      }
    }
  },
  {
    name: "source",
    title: 'Source',
    width: "30%"
  },
  {
    name: "isArchived",
    title: 'Archived',
    width: "30%",
    sortField: "isArchived",
    formatter(value) {
      if (value) {
        return "<span class='badge badge-danger custom-danger-alert'>Yes</span>";
      } else {
        return "<span class='badge badge-success custom-success-alert'>No</span>";
      }
    }
  },
  {
    name: "documentTag",
    title: 'Tag Documents',
    width: "30%"
  },
]